// extracted by mini-css-extract-plugin
export default {"root":"peacegame_SwitchLanguage_root"};